import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MasipService } from '../../services/masip.service';
import { Router } from '@angular/router';
import { ChangePageDialogComponent } from '../change-page-dialog/change-page-dialog.component';


@Component({
  selector: 'app-group-settings',
  standalone: false,
  templateUrl: './group-settings.component.html',
  styleUrl: './group-settings.component.scss'
})
export class GroupSettingsComponent {
 
  
  profiles: any;
  selected: boolean = false;
  isCustomConfiguration: boolean = false;
  selectedProfile: any[] = []; 

  constructor(
      public dialogRef: MatDialogRef<GroupSettingsComponent>,
      public dialog: MatDialog,
      private masipService: MasipService,
      private router: Router,
      @Inject(MAT_DIALOG_DATA) public data: { profile: any, },
    ) { }

    ngOnInit(){
     this.getProfilesByUser();
  
    }

    closeDialog() {
      this.dialogRef.close();
    }

    openConfiguration() {
      this.isCustomConfiguration = true;
    }

    getSettings(event: any) {
      this.selectedProfile = event;
    }

    closeConfiguration() {
      this.isCustomConfiguration = false;
  
    }

    getProfilesByUser() {
      var fiscalId = '';
      if (localStorage.getItem('accessAsUser') !== null) {
        fiscalId = String(localStorage.getItem('accessAsUser') || '');
      }
      this.masipService.setApiLoadingGlobal(true);
      this.masipService.getProfilesByUser(fiscalId).subscribe((resp: any) => {
        this.masipService.setApiLoadingGlobal(false);
        this.profiles = resp;

      }, (error: any) => {
        this.masipService.setApiLoadingGlobal(false);

      })
    }

    selectProfile(profile: any) {
      this.selectedProfile = profile;
    }

    saveProfile() {
      this.dialogRef.close(this.selectedProfile);
    }

    createProfile() {
      const dialogRef = this.dialog.open(ChangePageDialogComponent, {
        width: 'fit-content',
        height: 'fit-content',
  
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if (result === 'close') {
          this.closeDialog();
        }
      });
    }
}
